module.exports = __webpack_public_path__ + "static/media/andiePeterson.b66cc05d.jpg";